import { buildApiUrl, ADMIN_ENDPOINTS } from '../../configs/api.js'

export default {
  postUrl(payload) {
    return buildApiUrl(ADMIN_ENDPOINTS.SETTINGS_UPDATE || '/settings/update', {
      queryParams: {
        key: 'fees',
        service: 'rapidoo',
      },
    })
  },

  format(payload) {
    const { config } = payload || {}
    return {
      key: 'fees',
      category: 'fees',
      type: 'object',
      value: {
        ...config,
      },
      description: 'Application delivery fees configuration',
      isPublic: false,
      isEditable: true,
    }
  },

  parse(raw = {}, payload = {}) {
    if (!raw?.success && raw?.statusCode !== 200 && raw?.statusCode !== 201) {
      return {
        statusCode: raw?.statusCode || 500,
        message: raw?.message || 'Le serveur semble inaccessible',
        data: raw?.data || null,
      }
    }

    return {
      statusCode: 200,
      message: 'Ok',
      data: payload.config || {},
    }
  },
}
